import { render, staticRenderFns } from "./buktipotong1721.vue?vue&type=template&id=7a80ca84"
import script from "./buktipotong1721.vue?vue&type=script&lang=js"
export * from "./buktipotong1721.vue?vue&type=script&lang=js"
import style0 from "./buktipotong1721.vue?vue&type=style&index=0&id=7a80ca84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports